import { useParams } from 'react-router-dom';
import AutomationsStateHandler from './components/AutomationsStateHandler.jsx';
import AutomationDetailPage from './pages/AutomationDetailPage.jsx';
import AutomationListPage from './pages/AutomationListPage.jsx';
import AUTOMATION_KINDS from './lib/AUTOMATION_KINDS.js';
import './styles/automations.css';

/** Automations: the list of everything that runs on its own, and one automation's steps and runs. */
const AutomationsScreen = () => {
  const { automationType, automationId } = useParams();
  const kind = AUTOMATION_KINDS[automationType] ? automationType : null;

  return (
    <>
      <AutomationsStateHandler />
      {kind && automationId ? <AutomationDetailPage key={`${kind}-${automationId}`} kind={kind} id={automationId} /> : <AutomationListPage />}
    </>
  );
};

export default AutomationsScreen;
